const MATERIALS = [
  "Paper Cups", "Sugarcane Bagasse", "Aluminium Foil", "PP Containers",
  "Kraft Boxes", "Wooden Cutlery", "Pizza Boxes", "Paper Straws", "Cling Film",
];

export default function Marquee() {
  const row = [...MATERIALS, ...MATERIALS];
  return (
    <div className="relative py-6 bg-[#1D6B2A] overflow-hidden" data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap cp-marquee w-max">
        {row.map((m, i) => (
          <span key={i} className="flex items-center">
            <span className="font-head text-2xl md:text-3xl font-medium text-white/90 px-6">
              {m}
            </span>
            <span className="text-[#FDCD00] text-2xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
